import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { AuthService, SourceLocationService } from '../service';

@Component({
  selector: 'security-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallbackComponent implements OnInit {
  readonly #sourceLocationService = inject(SourceLocationService);

  readonly #authService = inject(AuthService);

  readonly #router = inject(Router);

  ngOnInit() {
    this.#authService
      .login()
      .pipe(
        tap(() => {
          const url = this.#sourceLocationService.get() ?? '/';
          this.#sourceLocationService.clear();

          this.#router.navigate([url]);
        }),
      )
      .subscribe();
  }
}
